/**
 * Audit log — registra ações administrativas no Supabase (`admin_audit_log`).
 *
 * Best-effort: erros silenciosos. Não bloqueia o fluxo do admin.
 *
 * Exemplos:
 *   logAdminAction('create', 'partner', partnerId, { name: 'Lumia' })
 *   logAdminAction('update', 'partner', partnerId, { changed: ['discount'] })
 *   logAdminAction('delete', 'partner', partnerId)
 *   logAdminAction('bulk_update', 'partner', null, { count: 5, active: false })
 */
import { supabase } from '../supabase';

type AuditAction =
  | 'create'
  | 'update'
  | 'delete'
  | 'bulk_update'
  | 'bulk_delete'
  | 'toggle'
  | 'send';
type EntityType =
  | 'partner'
  | 'student'
  | 'avatar'
  | 'mission'
  | 'banner'
  | 'notification'
  | 'smart_notification'
  | 'marketing_campaign'
  | 'customization_item'
  | 'settings';

interface AuditContext {
  userId?: string | null;
  userEmail?: string | null;
}

let currentContext: AuditContext = {};

export function setAuditContext(ctx: AuditContext): void {
  currentContext = ctx;
}

export async function logAdminAction(
  action: AuditAction,
  entityType: EntityType,
  entityId: string | null,
  details?: Record<string, unknown>,
): Promise<void> {
  try {
    await supabase.from('admin_audit_log').insert({
      action,
      entity_type: entityType,
      entity_id: entityId,
      details: details || {},
      user_id: currentContext.userId ?? null,
      user_email: currentContext.userEmail ?? null,
    });
  } catch (err) {
    // Silencioso — não queremos quebrar fluxo do admin por causa de log.
    console.warn('[auditLog] falha ao registrar', err);
  }
}
